<template>
  <form id="invoice-confirmation-form" class="form pt-3 pt-md-2 px-i">
    <div v-for="paymentMethod in paymentMethods" :key="paymentMethod.id" class="form-wrapper container-fluid mb-3 mb-md-4">
      <CheckBoxCard
        :resource="paymentMethod"
        :section-title="paymentMethod.title.en"
        :show-body="selectedPaymentMethod.name === paymentMethod.name"
        :selected-id="selectedPaymentMethod.id"
        class="mb-0"
        @setSelected="setPaymentMethod">
        <div v-if="selectedPaymentMethod.name === paymentMethod.name" class="invoice-details-row">
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              {{ invoice.voucher_template.voucher_type }}#
            </p>
            <p>{{ invoiceNumber }}</p>
          </div>
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              REFERENCE#
            </p>
            <p>{{ fawterNumber }}</p>
          </div>
          <div class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              DATE
            </p>
            <p>{{ invoiceDate | formatDateInNumeric(true) }}</p>
          </div>
          <div v-if="invoiceDueDate" class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              DUE DATE
            </p>
            <p>{{ invoiceDueDate | formatDateInNumeric(true) }}</p>
          </div>
          <div v-if="customerName" class="invoice-details-row-cell">
            <p class="invoice-details-row-cell-title">
              CUSTOMER
            </p>
            <p>{{ customerName }}</p>
          </div>
          <div class="invoice-details-row-cell invoice-details-row-cell-negative-margin">
            <p class="invoice-details-row-cell-title">
              STATUS
            </p>
            <div class="status-indicator status-indicator-rectangular flex-grow-0 flex-grow-sm-1" :class="pillColorClass">
              {{ invoiceStatus }}
            </div>
          </div>
        </div>

        <PaymentDetailsTable
          v-if="selectedPaymentMethod.name === paymentMethod.name"
          :payment-method="paymentMethod"
          :payment-fees="invoice.payment_fees"
          :currency-iso-code="invoice.currency_iso_code"
          :pass-on-fawter-fee="invoice.pass_on_fawter_fee"
          :invoice-total="invoice.total" />
        <OfflinePaymentInstructions
          v-if="selectedPaymentMethod.name === paymentMethod.name && selectedPaymentMethod.plugin === 'Offline'"
          :payment-fees="invoice.payment_fees"
          :currency-iso-code="invoice.currency_iso_code"
          :pass-on-fawter-fee="invoice.pass_on_fawter_fee"
          :tenant-invoice-number="invoice.tenant_invoice_number"
          :invoice-total="invoice.total"
          :payment-method-id="paymentMethod.id" />

        <MpgsPaymentForm
          v-else-if="selectedPaymentMethod.name === paymentMethod.name && selectedPaymentMethod.plugin === 'MPGS'"
          :payment-method="paymentMethod"
          :invoice-id="invoice.id" />
        <CheckoutPaymentForm
          v-else-if="selectedPaymentMethod.name === paymentMethod.name && selectedPaymentMethod.plugin === 'Checkout'"
          :invoice-id="invoice.id"
          :invoice-subtotal="invoice.invoice_subtotal"
          :invoice-total="invoice.total"
          :payment-method-id="paymentMethod.id"
          :checkout-payment-method="paymentMethod" />
      </CheckBoxCard>
    </div>
  </form>
</template>

<script>
import CheckBoxCard from "@shared/components/UI/CheckBoxCard.vue";
import PaymentDetailsTable from "../PaymentDetailsTable.vue";
import OfflinePaymentInstructions from "./OfflinePaymentInstructions.vue";
import MpgsPaymentForm from "./MpgsPaymentForm.vue";
import CheckoutPaymentForm from "./CheckoutPaymentForm.vue";

export default {
  name: "PaymentMethodsSection",

  components: {
    CheckBoxCard,
    PaymentDetailsTable,
    OfflinePaymentInstructions,
    MpgsPaymentForm,
    CheckoutPaymentForm
  },

  props: {
    paymentMethods: { type: Array },
    invoiceNumber: { type:[Number, String] },
    fawterNumber: { type: String },
    invoiceDate: { type: String },
    invoiceDueDate: { type: String },
    customerName: { type: String },
    invoiceStatus: { type: String },
    pillColorClass: { type: String },
    invoice: { type: Object }
  },

  data () {
    return {
      selectedPaymentMethod: this.paymentMethods[0]
    };
  },

  methods: {
    setPaymentMethod (paymentMethodId) {
      this.selectedPaymentMethod = this.paymentMethods.find(pm => pm.id.toString() === paymentMethodId.toString());
    }
  }
};
</script>
